import styled from 'styled-components';

//TODO: do we add the spacing, or will the iframe already have it?
export const StyledWrapper = styled.main`
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: space-between;
`;
